import { baseApi } from 'api/base';
import { EntryRegistrationDTO } from './types';

const get = async (id: string): Promise<EntryRegistrationDTO[]> => {
  const res = await baseApi.get(`/entry/${id}/registrations`);
  return res.data;
};

const edit = async (row: EntryRegistrationDTO, entryId: string) => {
  await baseApi.post(`/entry/${entryId}/registrations/${row.id}`, row);
};

const add = async (row: EntryRegistrationDTO, entryId: string) => {
  await baseApi.post(`/entry/${entryId}/registrations`, row);
};

const remove = async (entryId: string, rowId: string) => {
  await baseApi.delete(`/entry/${entryId}/registrations/${rowId}`);
};

export const entryRegistrationApi = {
  get,
  edit,
  add,
  remove,
};
